import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./CategoryDetailsBooth.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';

type WallInfo = {
  name: string;
  image: string;
  description: string;
  features: string[];
};

const wallData: Record<string, WallInfo> = {
  pink: {
    name: "Pink Flower Wall",
    image: "/images/pinkwall.jpg",
    description:
      "Our pink flower wall features lush roses and peonies in soft blush and vibrant pink tones. Perfect for weddings, bridal showers, baby showers, and romantic celebrations, this wall creates a stunning backdrop that your guests will love.",
    features: [
      "Lush pink roses and peonies",
      "8ft x 8ft coverage",
      "Professional stand included",
      "Setup and takedown included",
    ],
  },
  green: {
    name: "Green Flower Wall",
    image: "/images/greenwall.jpg",
    description:
      "Our green flower wall brings a fresh, natural feel with rich greenery and foliage. Ideal for corporate events, garden parties, and modern celebrations, this wall adds a touch of organic elegance to any venue.",
    features: [
      "Rich greenery and foliage",
      "8ft x 8ft coverage",
      "Professional stand included",
      "Setup and takedown included",
    ],
  },
  white: {
    name: "White Flower Wall",
    image: "/images/whitewall.jpg",
    description:
      "Our white flower wall offers a classic, timeless look with elegant white blooms. A beautiful choice for weddings, formal events, and upscale gatherings, this wall provides a clean and sophisticated backdrop for photos and decor.",
    features: [
      "Elegant white blooms",
      "8ft x 8ft coverage",
      "Professional stand included",
      "Setup and takedown included",
    ],
  },
};

const handleClick = () => {
  const element = document.getElementById("contact");
  if (element) {
    element.scrollIntoView();
  }
};

function FlowerWallDetail() {
  const { id } = useParams();
  const wall = id ? wallData[id] : undefined;

  useEffect(() => {
    const element = document.getElementById("service");
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  if (!wall) {
    return (
      <div>
        <section className="features">
          <Container>
            <div className="section-title">
              <h1>Flower Wall Not Found</h1>
              <p>The flower wall you are looking for does not exist.</p>
            </div>
          </Container>
        </section>
      </div>
    );
  }

  return (
    <div>
      <section className="features">
        <Container>
          <div className="section-title">
            <h1>{wall.name}</h1>
          </div>
          <Row className="justify-content-center align-items-center">
            <Col md={5} className="pt-4 product-box">
              <img src={wall.image} className="img-fluid" alt={wall.name} />
            </Col>
            <Col md={5} className="pt-4">
              <h3>About This Wall</h3>
              <p className="fst-italic">{wall.description}</p>
              <ul>
                {wall.features.map((feature, index) => (
                  <li key={index}>
                    <i className="bi bi-check"></i> {feature}
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="pricing section-bg" data-aos="fade-up">
        <div className="container">
          <div className="section-title">
            <h2>Pricing</h2>
          </div>
          <Row className="no-gutters justify-content-center align-items-center">
            <Col lg={4} className="box featured">
              <h3>Event Rental</h3>
              <h4>$150 for up to 24 hours</h4>
              <ul>
                <li><i className="bx bx-check"></i> Professional Stand</li>
                <li><i className="bx bx-check"></i> Setup & Takedown</li>
              </ul>
              <a onClick={handleClick} className="get-started-btn">Get Started</a>
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
}

export default FlowerWallDetail;
